/**
 * @param passwordValidator (password:string, minLength?:number)=> boolean
 * @param minLength for share link is 6(default), account password is 8
 * @returns string: combination of 6 digits & uppercase letters
 */
export const generatePassword = (passwordValidator, minLength: number = 6) => {
  const generate = () => {
    let pwd = '';
    while (pwd.length < minLength) {
      pwd += Math.random().toString(36).substr(2, 1);
    }
    return pwd.toUpperCase();
  };
  let password = generate();
  let isValid = passwordValidator(password);
  while (!isValid) {
    password = generate();
    isValid = passwordValidator(password);
  }

  return password;
};
